import React from 'react';

interface EditIconProps {
  className?: string;
  color?: string;
  size?: number;
}

const EditIcon: React.FC<EditIconProps> = ({ className = '', color = '', size = 24 }) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      style={{ color }}
    >
      <path
        d="M12.5308 6.2207L17.7808 11.4707M8.4709 20.4703H4.2809C4.0809 20.4703 3.89092 20.3922 3.74892 20.2502C3.60892 20.1102 3.5309 19.9203 3.5309 19.7203V15.5303C3.5289 15.4323 3.54891 15.3363 3.58491 15.2463C3.62291 15.1563 3.67689 15.0743 3.74489 15.0043L14.9949 3.75427C15.0649 3.68427 15.1489 3.62827 15.2409 3.59027C15.3329 3.55027 15.4309 3.53027 15.5309 3.53027C15.6289 3.53027 15.7289 3.55027 15.8189 3.59027C15.9109 3.62827 15.9949 3.68427 16.0649 3.75427L20.2449 7.93628C20.3169 8.00628 20.3729 8.08824 20.4109 8.18024C20.4489 8.27224 20.4689 8.37028 20.4689 8.47028C20.4689 8.57028 20.4489 8.66825 20.4109 8.76025C20.3729 8.85225 20.3169 8.93427 20.2449 9.00427L8.99489 20.2543C8.92689 20.3243 8.8449 20.3782 8.7549 20.4142C8.6649 20.4522 8.5689 20.4703 8.4709 20.4703Z"
        stroke="currentColor"
        strokeWidth={1.5}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default EditIcon;
